import classNames from 'classnames';
import React from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/layouts/display.module.scss';

interface FullscreenLayoutProps {
    pageLoading?: boolean;
    children?: React.ReactNode;
}

function FullscreenLayout({ pageLoading = false, children = null }: FullscreenLayoutProps) {
    const themeClassName = useThemeClassName(styles, true);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.pageLoading]: pageLoading,
                },
                themeClassName,
            ])}
        >
            <main className={styles.main}>{children}</main>
        </div>
    );
}

export default FullscreenLayout;
